import React from "react";
import classes from "./css/GridWrapper.module.css";

export default ({ type, ...props }) => (
  <div className={[classes.Wrapper, classes[type]].join(" ")}>
    {props.children}
  </div>
);
